// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"3baa3ccd","67":"e0c85f7b","111":"6e3606d2","294":"42a06a4f","386":"813ddd8d","453":"97f2d197","500":"aafb846b","775":"525d46bd","865":"1cc929d7","881":"cc7bcc06","886":"b0460c13"}[chunkId] + ".chunk.js";
};